/**
 * "Cereal" icon by Jacob Halton from the Noun Project.
 * - Source: https://thenounproject.com/browse/icons/term/cereal/
 * - License: Creative Commons Attribution (CC BY 3.0)
 * - License URL: https://creativecommons.org/licenses/by/3.0/
 */
import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CerealIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      // viewBox="-5.0 -10.0 110.0 135.0"
      viewBox="0 0 100 100">
      <g>
        <path
          // fill="#010101"
          d="M64.371,99.479l25.125-7.898V27.209l8.138-10.05H74.899L64.371,31.519L50.251,17.159L0,7.347l17.708,14.838
		v64.371L64.371,99.479z M25.926,58.271c0.134-9.605,7.381-17.13,16.189-16.807c8.811,0.323,15.843,8.372,15.709,17.979
		c-0.132,9.608-7.38,17.134-16.188,16.811c-8.811-0.325-15.843-8.374-15.71-17.981V58.271z"
        />
        <polygon
          // fill="#010101"
          points="51.925,14.77 64.371,27.45 73.643,14.647 93.386,14.647 100,4.72 37.254,0 30.437,10.959 
		24.647,1.605 7.058,1.526 11.047,7.523 	"
        />
        <path
          // fill="#010101"
          d="M41.675,73.381c7.356,0.27,13.406-6.013,13.517-14.034c0.003-0.061-0.001-0.119-0.001-0.18
		c-2.3-4.818-7.667-8.007-13.8-7.643c-5.75,0.342-10.604,3.709-12.787,8.301C29.173,67.19,34.771,73.127,41.675,73.381z
		 M41.477,54.369c4.891-0.27,9.195,2.003,11.224,5.499c-2.268,2.38-6.118,4.037-10.561,4.233c-4.583,0.198-8.691-1.21-11.164-3.505
		C32.842,57.143,36.804,54.63,41.477,54.369z"
        />
      </g>
    </SvgIcon>
  );
};

export default CerealIcon;
